import { Link } from "@inertiajs/react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import Main from "../../../components/layout/Main";
import MetaData from "../../../components/MetaData";
import Heading from "../../../components/theme/Heading";
import { formatDateTime, formatPrice } from "../../../lib/format";
import { Event } from "../../../types/Event";

const Show = ({ compensations, id, name, slug }: Event) => {
  return (
    <>
      <MetaData title={name} />
      <Main>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Heading component="h1" variant="h1">
            {name}
          </Heading>
          <Link href={`/events/${slug}`}>Bekijken</Link>
          <Link href={`/admin/events/${id}/edit`}>Bewerken</Link>
        </Box>
        <Typography component="h2" sx={{ marginY: "1em" }} variant="h2">
          Aanvragen
        </Typography>
        <TableContainer>
          <Table aria-label="simple table" sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow sx={{ "& th": { fontWeight: "bold" } }}>
                <TableCell>Id</TableCell>
                <TableCell>Tijdstip</TableCell>
                <TableCell>Naam</TableCell>
                <TableCell>Van</TableCell>
                <TableCell>Naar</TableCell>
                <TableCell>Geschatte prijs</TableCell>
                <TableCell>Werkelijke prijs</TableCell>
                <TableCell>IP</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Bewijs</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {compensations.map((compensation) => (
                <TableRow key={compensation.id}>
                  <TableCell>{compensation.id}</TableCell>
                  <TableCell>
                    {formatDateTime(compensation.createdAt)}
                  </TableCell>
                  <TableCell>{compensation.userName}</TableCell>
                  <TableCell>{compensation.from}</TableCell>
                  <TableCell>{compensation.to}</TableCell>
                  <TableCell>{formatPrice(compensation.price)}</TableCell>
                  <TableCell>{formatPrice(compensation.actualPrice)}</TableCell>
                  <TableCell>{compensation.ipAddress}</TableCell>
                  <TableCell>{compensation.status}</TableCell>
                  <TableCell>
                    {compensation.proofUrl && (
                      <a
                        href={compensation.proofUrl}
                        rel="noreferrer"
                        target="_blank"
                      >
                        Bekijk
                      </a>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Main>
    </>
  );
};

export default Show;
